import { cartItemsStatuses } from '../../constants';
import StorageApi from './Helpers/storageApi';
import CartItemsHelper from './Helpers/cartItemsHelper';
import SummaryHelper from './Helpers/summaryHelper';

const EXPIRATION_TIME = 86400000; // 24hours

export default class CartStorageApi {
  constructor() {
    this.storageApi = null;
    this.cartItemsHelper = null;
    this.summaryHelper = null;
    this.instance = null;
  }

  initIfNeeded(context) {
    if (!this.storageApi || !this.cartItemsHelper || !this.summaryHelper) {
      this.init(context);
    }
  }

  init(context) {
    const {
      instance,
      instanceId,
      platformUtilitiesApi: { storage },
    } = context;
    this.storageApi = new StorageApi(storage);
    this.summaryHelper = new SummaryHelper(this.storageApi, instanceId);
    this.cartItemsHelper = new CartItemsHelper(
      this.storageApi,
      this.summaryHelper,
    );
    this.instance = instance;
    this.clearStorageIfNeeded();
    this.validateItems();
  }

  clearStorageIfNeeded() {
    if (this.isEmptyCart()) {
      this.clearAll();
    }
  }

  isEmptyCart() {
    const summary = this.summaryHelper.getItemsSummary();
    return Object.keys(summary).length === 0;
  }

  setItemStatus(uuid, newStatus) {
    this.cartItemsHelper.setItemStatus(uuid, newStatus);
  }

  validateItems() {
    const summary = this.summaryHelper.getItemsSummary();
    const cartItems = this.cartItemsHelper.getAllCartItems();
    Object.keys(summary).forEach((uuid) => {
      const cartItem = cartItems[uuid];
      const cartItemExists = !!cartItem;
      if (!cartItemExists) {
        // no such item, delete from summary
        this.summaryHelper.removeItemFromSummary({ uuid });
      } else {
        const validQuantity = summary[uuid] > 0;
        const { quantity, timestamp } = cartItem;
        const currentDate = new Date().getTime();
        if (currentDate - timestamp > EXPIRATION_TIME) {
          // Cart item expired
          this.removeCartItem(cartItem);
        } else if (!validQuantity) {
          if (quantity > 0) {
            // valid item quantity, re-add it to summary
            this.summaryHelper.addItemToSummary(cartItem);
          } else {
            // invalid cart item - remove from storage
            this.removeCartItem(cartItem);
          }
        }
      }
    });
  }

  clearAll() {
    this.summaryHelper.clear();
    this.cartItemsHelper.clearAll();
  }

  addCartItem(item) {
    this.summaryHelper.addItemToSummary(item);
    this.cartItemsHelper.addCartItem(item);
  }

  removeCartItem(item) {
    this.cartItemsHelper.removeCartItem(item);
    this.summaryHelper.removeItemFromSummary(item);
    this.clearStorageIfNeeded();
  }

  updateCartItem(item) {
    this.summaryHelper.updateCartItemInSummary(item);
    this.cartItemsHelper.updateCartItem(item);
  }

  getCartItems() {
    const cartItems = this.cartItemsHelper.getAllCartItems();
    const itemsArray = [];
    Object.keys(cartItems).forEach((uuid) => itemsArray.push(cartItems[uuid]));
    return itemsArray.sort((item1, item2) => {
      const item1Timestamp = (item1 && item1.timestamp) || 0;
      const item2Timestamp = (item2 && item2.timestamp) || 0;
      return item1Timestamp - item2Timestamp;
    });
  }

  getCartItemsCount() {
    const summary = this.summaryHelper.getItemsSummary();
    let count = 0;
    Object.keys(summary).forEach((uuid) => (count += summary[uuid]));
    return count;
  }

  addToCart(data) {
    const item = {
      uuid: data.uuid,
      mediaUrl: data.mediaUrl || data.itemUrl,
      galleryId: data.galleryId,
      providerId: data.providerId,
      quantity: data.quantity,
      isDemo: data.isDemo,
      metadata: data.metadata,
      styleId: data.styleId,
      status: cartItemsStatuses.OK,
      timestamp: new Date().getTime(),
    };
    this.addCartItem(item);
    this.validateItems();
  }
}
